import debounce from 'lodash/debounce'

export default {
  data() {
    return {
      differenceForScroll: 200, // Sticky if content bigger than main container on this value
      isScrollEnabled: false,
      scrollContainer: null,
      stickyButtons: false,
    }
  },
  mounted() {
    this.scrollContainer = document.getElementById('main')
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    this.scrollContainer.removeEventListener('scroll', this.setScrollClass)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    setScrollSetting() {
      this.scrollContainer = document.getElementById('main')
      const contentContainer = document.getElementById('main-layout')
      if (contentContainer.offsetHeight - this.scrollContainer.offsetHeight > this.differenceForScroll) {
        this.isScrollEnabled = true
        this.scrollContainer.addEventListener('scroll', this.setScrollClass)
      } else {
        this.isScrollEnabled = false
        this.scrollContainer.removeEventListener('scroll', this.setScrollClass)
      }
    },
    setScrollClass: debounce(function() {
      this.stickyButtons = this.scrollContainer.scrollTop > 100
    }, 50),
    onResize: debounce(function() {
      this.setScrollSetting()
    }, 250),
  },
}
